import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const anchorNavigationItemSectionFn = /* @__PURE__ */ createRecipe('anchor-navigation-item-section', {}, [])

const anchorNavigationItemSectionVariantMap = {}

const anchorNavigationItemSectionVariantKeys = Object.keys(anchorNavigationItemSectionVariantMap)

export const anchorNavigationItemSection = /* @__PURE__ */ Object.assign(memo(anchorNavigationItemSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'anchorNavigationItemSection',
  __getCompoundVariantCss__: anchorNavigationItemSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: anchorNavigationItemSectionVariantKeys,
  variantMap: anchorNavigationItemSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, anchorNavigationItemSectionVariantKeys)
  },
  getVariantProps: anchorNavigationItemSectionFn.getVariantProps,
})